import Typography from '@mui/material/Typography'
import DialogConfirm, { DialogConfirmProps } from './DialogConfirm'

interface Props extends DialogConfirmProps {
  message: string
}

function DeleteConfirm({ message, children, ...props }: Props) {
  return (
    <DialogConfirm
      color="error"
      action="Delete"
      dialogChildren={
        <Typography variant="body1" component="div">
          {message}
        </Typography>
      }
      {...props}
      sx={{ display: 'inline-flex', ...props.sx }}
    >
      {children}
    </DialogConfirm>
  )
}

export default DeleteConfirm
